import { Link } from 'react-router-dom';

// icons
import { faFileCheck } from '@fortawesome/pro-regular-svg-icons';
import { Grid, useTheme } from '@mui/material';

// components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useActor } from '../../../../components/hooks/useActor';
import { SolidButton, StyledHeader, StyledParagraph } from './styles';

export const ApproveQuote = ({
  quote = {},
  canQuoteBeApproved = true,
}: any) => {
  const actor = useActor();
  const theme = useTheme();

  let availableUrl = `/customer/quotes/${quote.id}/approve/${quote.product}`;

  if (quote.customerEmail !== actor.email) {
    availableUrl = `/customer/quotes/${quote.id}/insuredName/${quote.product}`;
  }

  if (!canQuoteBeApproved) {
    return (
      <Grid container columnSpacing={2} rowSpacing={2}>
        <Grid
          item
          md={3}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <FontAwesomeIcon
            icon={faFileCheck}
            size="4x"
            color={theme.palette.common.gunmetalBlue}
          />
        </Grid>
        <Grid item md={9}>
          <StyledHeader>Approve</StyledHeader>
          <StyledParagraph>
            Quote has subjectivities that must be completed. Please contact your
            agent for more information.
          </StyledParagraph>
          <SolidButton
            type="submit"
            sx={{ marginTop: '1rem', width: '100% !important' }}
            disabled
          >
            Approve
          </SolidButton>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container columnSpacing={2} rowSpacing={2}>
      <Grid
        item
        md={3}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <FontAwesomeIcon
          icon={faFileCheck}
          size="4x"
          color={theme.palette.common.gunmetalBlue}
        />
      </Grid>
      <Grid item md={9}>
        <StyledHeader>Approve</StyledHeader>
        <StyledParagraph>
          Quote(s) are ready for your review and approval
        </StyledParagraph>
        <Link to={availableUrl}>
          <SolidButton
            type="submit"
            sx={{ marginTop: '1rem', width: '100% !important' }}
          >
            Approve
          </SolidButton>
        </Link>
      </Grid>
    </Grid>
  );
};
